import { Box } from "@mui/material";
import React, { useEffect } from "react";

// https://codepen.io/Gthibaud/pen/ENzXbp
const colors = [
  "rgb(30,144,255)",
  "rgb(107,142,35)",
  "rgb(255,215,0)",
  "rgb(255,192,203)",
  "rgb(106,90,205)",
  "rgb(173,216,230)",
  "rgb(238,130,238)",
  "rgb(152,251,152)",
  "rgb(70,130,180)",
  "rgb(244,164,96)",
  "rgb(210,105,30)",
  "rgb(220,20,60)",
];
const styles = {
  rainbowText: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // rainbow background with clip
    background:
      "linear-gradient(90deg, #ff0000, #ffa500, #ffff00, #008000, #0000ff, #4b0082, #ee82ee)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontSize: "100px",
    fontWeight: "bold",
    // textShadow: '0 0 10px #000',
  },
};
const params = {
  // particleCount: 2000,
  particleCount: 20,
  animating: true,
  speed: 1,
  gravity: 0.007,
  step: 0,
  extraCannons: 0,
  scale: 1,
};
const createParticle = (x, y, dx, dy, waveAngle = 0, color = null) => {
  const particle = {};
  particle.color = color
    ? color
    : colors[Math.floor(Math.random() * colors.length)];
  particle.x = x;
  particle.y = y;
  particle.dx = dx * params.scale;
  particle.dy = dy * params.scale;

  particle.friction = Math.random() * (0.997 - 0.992) + 0.992;
  particle.size = Math.floor((2 + Math.random() * 4) * params.scale);
  particle.step = 0;

  particle.rotationOffset = Math.random() * 2 * Math.PI;
  particle.wave = 0;
  particle.waveBase = Math.random() * 0.04 - 0.02;
  particle.waveAmplitude = Math.random() * 0.02 + 0.01;
  particle.waveAngle = waveAngle;
  particle.dWaveAngle = Math.random() * 0.1;
  return particle;
};

const drawParticles = (particles, ctx) => {
  for (let i = 0; i < particles.length; i++) {
    const particle = particles[i];
    ctx.translate(particle.x, particle.y);
    ctx.rotate(particle.dx * 2);
    ctx.scale(1, particle.step);
    ctx.fillStyle = particle.color;
    ctx.fillRect(
      -particle.size / 2,
      -particle.size / 2,
      particle.size,
      particle.size
    );
    ctx.resetTransform();
  }
  // write the current step
  // ctx.fillStyle = 'black';
  // ctx.font = '20px Arial';
  // ctx.fillText(Math.floor(params.step / 60), 10, 50);
};

const updateParticles = (particles, ctx, timeWeight = 1) => {
  if (timeWeight > 5) {
    timeWeight = 5;
  }
  for (let i = 0; i < particles.length; i++) {
    const particle = particles[i];
    // particle.dy += params.gravity * params.scale * timeWeight;
    // particle.dy *= particle.friction * timeWeight;
    // particle.dx *= particle.friction * timeWeight;
    particle.dy += params.gravity * params.scale * timeWeight;
    particle.dy *= Math.pow(particle.friction, timeWeight);
    particle.dx *= Math.pow(particle.friction, timeWeight);
    particle.x += particle.dx * timeWeight;
    particle.y += particle.dy * timeWeight;

    // custom formula for "step" which controls the "size" of particle
    // fast changing size makes the confetti "flip" in the air faster
    // Math.sqrt(...dy) makes the confetti flip slower when moving at high speeds
    // which makes the initial animation less epileptic
    particle.step =
      0.5 +
      Math.sin(
        Math.sqrt(Math.abs(particle.dy)) * 50 + particle.rotationOffset
      ) *
        0.5;
    // particle.wave =
    //   particle.waveBase + Math.cos(particle.waveAngle) * particle.waveAmplitude;
    // particle.waveAngle += particle.dWaveAngle;
  }
  params.step += timeWeight;

  // extra confetti streaming from sides
  // if (params.step < 240 && params.step % 8 === 0) {
  // for (let i = 0; i < 40; i++) {
  //   if (params.step < 200 && params.step % 60 === 1) {
  if (params.extraCannons < 4 && params.step > params.extraCannons * 60) {
    params.extraCannons += 1;
    for (let i = 0; i < 80 - params.step / 5; i++) {
      particles.push(
        createParticle(
          -10,
          ctx.canvas.height > ctx.canvas.width
            ? ctx.canvas.height * 0.5
            : ctx.canvas.height * 0.8,
          Math.random() * 1.5 + 1.6,
          Math.random() * 1 - 3
        )
      );
      particles.push(
        createParticle(
          ctx.canvas.width + 10,
          ctx.canvas.height > ctx.canvas.width
            ? ctx.canvas.height * 0.5
            : ctx.canvas.height * 0.8,
          -(Math.random() * 1.5 + 1.6),
          Math.random() * 1 - 3,
          Math.PI
        )
      );
    }
  }
  return params.step < 5000;
};

const Confetti = () => {
  const canvasRef = React.useRef(null);

  useEffect(() => {
    const startConfetti = () => {
      console.log("started confetti");
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      params.scale = window.innerWidth / 400;
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      // test drawing
      // ctx.fillStyle = '#000000'
      // ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height)
      const particles = [];

      // confetti in center
      // for (let i = 0; i < 50; i++) {
      //     particles.push(createParticle(
      //         ctx.canvas.width / 2, ctx.canvas.height * 0.4,
      //         Math.random() * 2 - 1, Math.random() * 2 - 1.4, Math.random() * Math.PI, '#12aafd'))
      // }

      // confetti from sides
      // for (let i = 0; i < params.particleCount; i++) {
      //     particles.push(createParticle(
      //         -10, ctx.canvas.height > ctx.canvas.width ? ctx.canvas.height * 0.5 : ctx.canvas.height * 0.8,
      //         Math.random() * 1.5 + 1.6, Math.random() * 1 - 3.))
      //     particles.push(createParticle(
      //         ctx.canvas.width + 10, ctx.canvas.height > ctx.canvas.width ? ctx.canvas.height * 0.5 : ctx.canvas.height * 0.8,
      //         -(Math.random() * 1.5 + 1.6), (Math.random() * 1 - 3.), Math.PI))
      // }
      let lastRender = Date.now();
      const render = () => {
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
        drawParticles(particles, ctx);
        const now = Date.now();
        // console.log((now - lastRender) / (1000 / 60));
        const shouldContinue = updateParticles(
          particles,
          ctx,
          (now - lastRender) / (1000 / 60)
        );
        lastRender = now;
        if (shouldContinue) {
          //   setTimeout(render, 1000 / 40);
          requestAnimationFrame(render);
        }
      };
      render();
    };
    setTimeout(startConfetti, 250);
    // startConfetti()
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        width: "100vw",
        height: "100vh",
        zIndex: "100",
        pointerEvents: "none",
      }}>
      <canvas
        ref={canvasRef}
        style={{
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
      />
      {/* <Box sx={styles.rainbowText}>Congratulations!</Box> */}
    </div>
  );
};

export default Confetti;
